import { Component, OnInit } from '@angular/core';
import { SignatureModalComponent } from '../signature-modal/signature-modal.component';
import { SignatureBulkModalComponent } from '../signature-bulk-modal/signature-bulk-modal.component'; 
import { ReviewerModalComponent } from '../reviewer-modal/reviewer-modal.component';
import {NgbModal, ModalDismissReasons, NgbModalOptions, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
// import { FileUploadService } from 'src/app/services/file-upload.service';
import { MifielSignatureService } from 'src/app/services/mifiel-signature.service';
import { HttpEventType, HttpResponse , HttpErrorResponse} from '@angular/common/http';

import { FileBlobService } from '../../services/file-blob.service';

import { ToastrService } from 'ngx-toastr';

import { NavigationEnd,ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ErrorHandlerService } from '../../services/error-handler.service';
// import { MiFielSignatureService } from '../../services/mi-fiel-signature.service'
import { filter } from 'rxjs/operators';

class MifielData {
  message_for_signers: string = '';
  days_to_expire: number = 0;
  remind_every: number = 0;
  send_invites: boolean = true;
  sign_callback_url: string ='';
  signatories: string [][] = [];
  viewers: string [][] = [];
  userTaxId: string = '';
  TargetTaxId: string = '';
}


class Viewers {
  email: string = '';
  name: string = '';
}

// class DatosDetalles {
//   sizeArchivo: string;
//   nombreArchivo: string;
//   tipoCopiaCertificada: string;
// }

class PdfFile {
  size: string = '';
  name: string = '';
  type: string = '';
}


@Component({
  selector: 'app-signature-fiel',
  templateUrl: './signature-fiel.component.html',
  styleUrls: ['./signature-fiel.component.css']
})
export class SignatureFielComponent implements OnInit {
  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';
  fileInfos?: Observable<any>;
  private scriptParentNode?: Node;
  // datosPdf = false;
  validPdf: boolean = false;
  maxFileSize: number = 0;
  actualFileSize?: number = 0;
  convertedActualFileSize?: string = '';
  // pdfContent: Uint8Array | undefined;
  // pdfContent: Uint8Array | undefined = undefined;
  pdfContent: Uint8Array = new Uint8Array(0);
  mifielData: MifielData = new MifielData();
  pdfFile: PdfFile = new PdfFile();
  
  viewers = Viewers;
  // use true to use on production
  demoData: boolean = true;

  pdfSrc: Uint8Array;
  pdfContent2: Uint8Array = new Uint8Array(0);
  fileBlob: Blob =  new Blob([''], { type: 'application/pdf' });
  fileName: string = "file.pdf";
  fileTaxId: string = "";
  numViewers: number = 0;
  numSigners: number = 0;
  public zoom: number | string = 'page-fit';
  public rotation: 0 | 90 | 180 | 270 = 0;
  public sidebarVisible = true;
  count: number;
  canSignDocuments: boolean = false;

  // private routerSubscription: Subscription;
  credits: number;
  thisMonthUsedCredits: number;

  constructor(private uploadService: MifielSignatureService, 
    private modalService: NgbModal,
    private fileBlobService: FileBlobService, 
    private toastr: ToastrService, 
    private router: Router,
    private errorHandler: ErrorHandlerService,
    private miFielSignatureService: MifielSignatureService, 
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (this.demoData) {
      this.mifielData.message_for_signers='Favor de Firmar con Firma Electrónica';
      this.mifielData.days_to_expire=5;
      this.mifielData.remind_every=1;
      this.mifielData.send_invites=true;
    }
    this.fileBlob = this.fileBlobService.getFileBlob();
    this.fileName = this.fileBlobService.getfileName();
    this.fileTaxId = this.fileBlobService.getFileTaxId();
    console.log("fileName:"); 
    console.log(this.fileName);
    console.log("fileTaxId:"); 
    console.log(this.fileTaxId);
    this.loadCount(localStorage.getItem('userTaxId'));
    this.credits = this.uploadService.getMaxMonthSignatures();
    // this.paramSubscription = this.route.params.subscribe(params => {
    //   this.itemId = +params['id']; // The '+' converts the string to a number
    //   this.loadData(this.itemId);
    // });
    // this.routerSubscription = this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   // Code here will run on every navigation end event
    //   this.runMyCode();
    // });
  }

  // runMyCode(): void {
  //   console.log('Navigation ended, component is active.');
  //   this.loadCount(localStorage.getItem('userTaxId'));
  // }


  // loadData(id: number): void {
  //   // Load your data here based on the new ID
  //   console.log(`Loading data for item ${id}`);
  //   this.loadCount(localStorage.getItem('userTaxId'));
  // }

  // ngOnDestroy(): void {
  //   this.routerSubscription.unsubscribe(); // Always good practice to unsubscribe
  // }


  // convertBlobToFile(blob, fileName) {
  //   blob.lastModifiedDate = new Date();
  //   blob.name = fileName;
  //   return blob;
  // }

  // base64ToArrayBuffer(base64: any): any {
  //   var output = atob(base64.replace(/\s/g, ""));
  //   let binaryString = window.atob(output);
  //   let binaryLen = binaryString.length;
  //   let bytes = new Uint8Array(binaryLen);
  //   for (let i = 0; i < binaryLen; i++) {
  //     let ascii = binaryString.charCodeAt(i);
  //     bytes[i] = ascii;
  //   }
  //   return bytes;
  // }

  // base64ToArrayBuffer(base64: string): ArrayBuffer {
  //   const binaryString = window.atob(base64);
  //   const len = binaryString.length;
  //   const bytes = new Uint8Array(len);
  //   for (let i = 0; i < len; ++i) {
  //     bytes[i] = binaryString.charCodeAt(i);
  //   }
  //   return bytes.buffer;
  // }

  // base64ToArrayBuffer(base64: string): Promise<ArrayBuffer> {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       const binaryString = window.atob(base64);
  //       const len = binaryString.length;
  //       const bytes = new Uint8Array(len);
  //       for (let i = 0; i < len; ++i) {
  //         bytes[i] = binaryString.charCodeAt(i);
  //       }
  //       resolve(bytes.buffer);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  // base64ToArrayBuffer(base64: string): Promise<ArrayBuffer> {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       // Remove data URI prefix if present
  //       const base64Data = base64.replace(/^data:application\/pdf;base64,/, '');
  
  //       // Trim whitespace
  //       const trimmedData = base64Data.trim();
  
  //       // Decode base64 string
  //       const binaryString = window.atob(trimmedData);
        
  //       // Convert binary string to Uint8Array
  //       const len = binaryString.length;
  //       const bytes = new Uint8Array(len);
  //       for (let i = 0; i < len; ++i) {
  //         bytes[i] = binaryString.charCodeAt(i);
  //       }
  
  //       resolve(bytes.buffer);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }


  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
    // this.actualFileSize = this.selectedFiles?.item(0)?.size;
    this.actualFileSize = this.selectedFiles.item(0).size;
    this.validPdf = false;
  
    if (this.selectedFiles && this.actualFileSize !== undefined) {
      const maxSizeInBytes = 20 * 1024 * 1024; // 20 MB in bytes
  
      if (this.actualFileSize <= maxSizeInBytes) {
        this.validPdf = true;
        const file = this.selectedFiles[0]; // Use the first file in the list
        // const file = event.target.files[0]; // Another way to get the first file
  
        this.loadPdfContent(file).then((pdfContent) => {
          this.pdfContent = pdfContent;
        }).catch((error) => {
          console.error('Error loading PDF content:', error);
        });
  
        console.info("File size ok" + this.formatFileSize(this.actualFileSize));
        this.convertedActualFileSize = this.formatFileSize(this.actualFileSize);
      } else {
        console.error('File size exceeds the allowed limit (20 MB).');
        this.pdfContent = new Uint8Array(0);
      }
    }
  }
  


//  Angular 12
  loadPdfContent(file: File): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        // const arrayBuffer = event.target?.result as ArrayBuffer;
        // const arrayBuffer = event.target.result as ArrayBuffer;
        const arrayBuffer = event.target.result as ArrayBuffer;
        if (arrayBuffer) {
          const uint8Array = new Uint8Array(arrayBuffer);
          resolve(uint8Array);
        } else {
          reject(new Error('Failed to read file content.'));
        }
      };
  
      // Pass the File object directly to readAsArrayBuffer
      reader.readAsArrayBuffer(file);
    });
  }

  // angular 7
  // loadPdfContent(file: File): Promise<Uint8Array> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = (event: ProgressEvent) => {
  //       if (event.target && event.target instanceof FileReader) {
  //         const fileReader = event.target as FileReader;
  //         const arrayBuffer = fileReader.result as ArrayBuffer;
  //         if (arrayBuffer) {
  //           const uint8Array = new Uint8Array(arrayBuffer);
  //           resolve(uint8Array);
  //         } else {
  //           reject(new Error('Failed to read file content.'));
  //         }
  //       } else {
  //         reject(new Error('Invalid target or target type.'));
  //       }
  //     };
  
  //     // Pass the File object directly to readAsArrayBuffer
  //     reader.readAsArrayBuffer(file);
  //   });
  // }
  



  formatFileSize(sizeInBytes: number): string {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;
  
    if (sizeInBytes < KB) {
      return sizeInBytes + ' B';
    } else if (sizeInBytes < MB) {
      return (sizeInBytes / KB).toFixed(2) + ' KB';
    } else if (sizeInBytes < GB) {
      return (sizeInBytes / MB).toFixed(2) + ' MB';
    } else {
      return (sizeInBytes / GB).toFixed(2) + ' GB';
    }
  }

  upload(): void {
    this.progress = 0;

    if (this.selectedFiles) {

      // if (this.fileBlob) {
      //   const file = this.fileBlob;
      // } else {
        const file: File | null = this.selectedFiles.item(0);
      // }
      

      if (file) {
        this.currentFile = file;
        console.log("Inside upload");
        console.log(this.currentFile.name);
        this.mifielData.TargetTaxId = this.fileTaxId;
        this.mifielData.userTaxId = localStorage.getItem('userTaxId');
        this.uploadService.upload(this.currentFile,this.mifielData).subscribe(
          (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event instanceof HttpResponse) {
              // this.message = event.body?.message || 'Upload successful';
              this.message = event.body.message || 'Upload successful';
              // this.message = event.body.message;
              // this.fileInfos = this.uploadService.getFiles();
              this.pdfContent = null;
            }
          },
          (err: any) => {
            console.log(err);
            this.progress = 0;

            if (err.error && err.error.message) {
              this.message = err.error.message;
            } else {
              this.message = 'Could not upload the file! (js)';
            }

            this.currentFile = undefined;
          });

      }

      this.selectedFiles = undefined;
      this.progress = 0;
      this.loadCount(localStorage.getItem('userTaxId'));
    }
  }

  uploadContract(): void{
    
    this.currentFile = new File([this.fileBlob], this.fileName, {type: "application/pdf", lastModified: Date.now()});
    console.log("Inside uploadContract");
    console.log(this.currentFile);
    this.mifielData.TargetTaxId = this.fileTaxId;
    this.mifielData.userTaxId = localStorage.getItem('userTaxId');
    console.log("mifielData before submit:")
    console.log(this.mifielData);
    this.uploadService.upload(this.currentFile,this.mifielData).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          // this.message = event.body?.message || 'Upload successful';
          this.message = event.body.message || 'Upload successful';
          // this.message = event.body.message;
          // this.fileInfos = this.uploadService.getFiles();
          this.fileBlob = null;
          this.fileBlobService.setFileBlob(null,null,null);
          this.loadCount(localStorage.getItem('userTaxId'));
        }
      },
      (err: any) => {
        console.log(err);
        this.progress = 0;

        if (err.error && err.error.message) {
          this.message = err.error.message;
        } else {
          this.message = 'Could not upload the file! (js)';
        }

        this.currentFile = undefined;
        this.loadCount(localStorage.getItem('userTaxId'));
      });
  }

  openSignature() {
    const modalRef = this.modalService.open(SignatureModalComponent);
    modalRef.componentInstance.my_modal_title = 'Firmante';
    modalRef.componentInstance.my_modal_content = 'I am your content';

    modalRef.result.then(
      (result) => {
        // Handle the result data from the modal here
        console.log('Modal closed with result:', result);
        let a: string[] = [result.email_person, this.replaceAccents(result.name),result.tax_id]; 
        this.mifielData.signatories.push(a);
        this.numSigners = this.mifielData.signatories.length;
        console.log(this.mifielData.signatories);
      },
      (reason) => {
        // Handle the modal dismissal or closing without result here
        console.log('Modal dismissed with reason:', reason);
      }
    );
    this.loadCount(localStorage.getItem('userTaxId'));
  }

  openSignatureBulk() {
    const modalRef = this.modalService.open(SignatureBulkModalComponent);
    modalRef.componentInstance.my_modal_title = 'Firmante';
    modalRef.componentInstance.my_modal_content = 'I am your content';

    modalRef.result.then(
      (result) => {
        // Handle the result data from the modal here
        console.log('Modal closed with result:', result);
        
        for(let i=1; i < result.length; i++){
          const item = result[i]
          let a: string[] = [item.email, this.replaceAccents(item.fullName), item.rfc]; 
          this.mifielData.signatories.push(a);
          this.numSigners = this.mifielData.signatories.length;
        }
        // this.mifielData.signatories.push(a);
        // this.numSigners = this.mifielData.signatories.length;
        // console.log(this.mifielData.signatories);
      },
      (reason) => {
        // Handle the modal dismissal or closing without result here
        console.log('Modal dismissed with reason:', reason);
      }
    );
    this.loadCount(localStorage.getItem('userTaxId'));
  }

  openReviewer() {
    const modalRef = this.modalService.open(ReviewerModalComponent);
    modalRef.componentInstance.my_modal_title = 'Espectador';
    modalRef.componentInstance.my_modal_content = 'I am your content';

    modalRef.result.then(
      (result) => {
        // Handle the result data from the modal here
        console.log('Modal closed with result:', result);
        let b: string[] = [result.email_person, this.replaceAccents(result.name)]; 
        this.mifielData.viewers.push(b);
        this.numViewers = this.mifielData.viewers.length;
        console.log(this.mifielData.viewers.length);
      },
      (reason) => {
        // Handle the modal dismissal or closing without result here
        console.log('Modal dismissed with reason:', reason);
      }
    );
    this.loadCount(localStorage.getItem('userTaxId'));
  }

  deleteSignatory(index: number): void {
    // Remove the signatory at the specified index

    this.mifielData.signatories.splice(index, 1);
    this.numSigners = this.mifielData.signatories.length;
    

  }

  deleteViewer(index: number): void {
    // Remove the signatory at the specified index
    this.mifielData.viewers.splice(index, 1);
    this.numViewers = this.mifielData.viewers.length;
  }


  // loadCount(userTaxId: string): void {
  //   this.uploadService.getCountByUserTaxId(userTaxId).subscribe(
  //     (data: any) => {
  //     //   this.count = data;
  //     //   console.log('Server Says...');
  //     //   console.log(data);
  //     // },
  //     next: (data) => {
  //       // handle data
  //             //   console.log('Server Says...');
  //     //   console.log(data);
  //     },
  //     error => {
  //       console.error('There was an error!', error);
  //       // this.checkForError(error);
  //       this.errorHandler.checkForError(error);
  //     }
  //   );
  // }

  loadCount(userTaxId: string): void {
    // Example of using an HTTP service that might fail

    this.uploadService.getCountByUserTaxId(userTaxId).subscribe({
      next: (data) => {
        console.log('Server Says...');
        // console.log(data);
        // console.log(typeof(data));
        console.log(data['thisMonthSignatures'])
        console.log(this.miFielSignatureService.getMaxMonthSignatures());
        if(this.miFielSignatureService.getMaxMonthSignatures() == null){
          localStorage.clear();
          this.router.navigate(['/']);
        }
        this.thisMonthUsedCredits = data['thisMonthSignatures'];
        if(  (this.miFielSignatureService.getMaxMonthSignatures() - this.thisMonthUsedCredits) > 0){
          this.canSignDocuments = true;
          console.log('can sign documents');
        }
        else{
          console.log('you can not sign, not credits left');
        }
      },
      error: (error) => {
        this.errorHandler.checkForError(error,'signature-fiel -> loadCount');
      }
    });
  }

//  checkForError(error: HttpErrorResponse): void {
//     console.trace()
//     if (error.status === 0) {
//       // this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener las sociedades');
//       this.toastr.error('No existe conexión con el servidor')
//     } else if (error.status === 403) {
//       // this.showMessage('error', 'La sesión expiro', 'Tiempo de sesión expirado');
//       this.toastr.error('La sesión expiro', 'Tiempo de sesión expirado');
//       this.goLogin();
//     } else {
//       // this.showMessage('error', 'Error en el servidor', 'Error desconocido, contacte con TuVidaDigital');
//       this.toastr.error('La sesión expiro', 'Tiempo de sesión expirado');
//       this.goLogin();
//     }    
//  }

//  goLogin() {
//     localStorage.clear();
//     this.router.navigate(['/']);
//   }

replaceAccents(str: string): string {
    console.log("Replacing: " + str)
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                              .replace(/ñ/g, "n")
                              .replace(/Ñ/g, "N");
}

}
